import { Select } from "antd";
import selectArrowIcon from "@assets/icons/select_arrow_active.svg";

export default function CustomSelect({
  onChange,
  value,
  options,
  className = "custom-select",
  variant = "borderless",
  icon = selectArrowIcon,
  label = "",
  placeholder = "",
  showSearch = false,
}) {
  return label ? (
    <div className="flex flex-col gap-1.5">
      <label className="text-xs">{label}</label>
      <Select
        onChange={onChange}
        value={value}
        options={options}
        className={className}
        variant={variant}
        suffixIcon={<img alt="arrow" src={icon} />}
        popupMatchSelectWidth={false}
        placeholder={placeholder}
        showSearch={showSearch}
      />
    </div>
  ) : (
    <Select
      onChange={onChange}
      value={value}
      options={options}
      className={className}
      variant={variant}
      suffixIcon={<img alt="arrow" src={icon} />}
      popupMatchSelectWidth={false}
      placeholder={placeholder}
    />
  );
}
